@if (displayPersoLabel$ | async) {
<div>
    <h-tag [appearance]="'border-square'" [tagSize]="'small'" [backgroundColor]="'transparent'">
        <div class="vertical-align">
            <span i18n="@@hermes.personalization.personalize" class="label-personalize label-small-bold-uppercase"
                >Personalize</span
            >
        </div>
    </h-tag>
</div>
}
